module.exports = __webpack_public_path__ + "static/media/SchoolCosHowItWorks1.44b6b604.png";